var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options)?_c('div',{staticClass:"chart-legend"},_vm._l((_vm.options),function(o,index){return _c('div',{key:_vm.composite_key(o.keys),staticClass:"option"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.composite_key(o.keys)))]),_c('div',{class:`line bg-${index + 1}`})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }